import { ratingTypes } from './ratingTypes';

export const titleByRatingType = {
  [ratingTypes.CREDIT_RATING]: 'Credit Rating',
  [ratingTypes.CREDIT_REVIEW]: 'Credit Review',
  [ratingTypes.ESG_IMPACT]: 'ESG Impact',
  [ratingTypes.SENTIMENT]: 'ESG Sentiment',
  [ratingTypes.CLIMATE_STRESS_TEST]: 'Climate Stress Test',
};
